import { render, staticRenderFns } from "./ChatClusterInfo.vue?vue&type=template&id=049b0fc8&"
import script from "./ChatClusterInfo.vue?vue&type=script&lang=js&"
export * from "./ChatClusterInfo.vue?vue&type=script&lang=js&"
import style0 from "./ChatClusterInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports